import React from "react";

export default function About() {
  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
      <h1 style={{ textAlign: "center" }}>About MIKEYME</h1>

      <p>
        MIKEYME is a small, family-run farm dedicated to producing high-quality THCA hash rosin, disposables, and hemp flower at prices that everyone can enjoy. 
        Our mission is to provide safe, consistent, and affordable products while sharing the story of our farm and passion for the plant.
      </p>

      <p>
        <strong>THC vs THCA:</strong> THCA is the raw, non-psychoactive compound found in hemp. It converts into THC when heated (decarboxylated). This means our products offer the benefits of THCA while remaining compliant with hemp laws.
      </p>

      <p>
        We believe that everyone should have access to quality hemp products, and we strive to make MIKEYME your go-to source for budget-friendly, reliable THCA flower and concentrates.
      </p>

      <p style={{ textAlign: "center", marginTop: "2rem" }}>
        Thank you for supporting our farm and helping us grow!
      </p>
    </div>
  );
  }
